import cloneDeep from "lodash/cloneDeep";

const addCustomFieldsValidation = (allCustomFields, data, baseValidations) => {
  if (allCustomFields.length === 0)
    return { validations: baseValidations, updatedData: data };

  let validations = cloneDeep(baseValidations);
  let validationData = Object.assign({}, data);

  allCustomFields.forEach((custom_field) => {
    const elementId = `custom_field_${custom_field.area}_${custom_field.custom_field_id}`;
    Object.assign(validationData, { [elementId]: custom_field.value });

    validations.fields[elementId] = {
      validations: {},
    };

    if (custom_field.required) {
      validations.fields[elementId].validations.empty = {
        errorMessageKey: "information.required-field",
      };
    }

    if (custom_field.is_date_restricted && custom_field.type == "date") {
      validations.fields[elementId].validations.date = {
        errorMessageKey: "information.date-restricted",
      };
    }
  });

  return { validations: validations, updatedData: validationData };
};

export default addCustomFieldsValidation;
